module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/en/4-faaecd40c8b3210e1168b36e865ebc4f.jpg";